import React, { useContext, useEffect, useState } from "react";
import AnalysisTable from "../../components/Table/AnalysisTable";
import AnalysisChart from "../../components/Cards/AnalysisChart";
// import { getSSOToken, custData, custDataNew } from "../faultCodeAnalysis/kpi";
import { fetchFaultcodeData } from "../faultCodeAnalysis/kpi";
import { FilterContext } from "../../context/Filter";

function FaultCode() {
  const [loading, setLoading] = useState(true);
  const [faultData, setFaultData] = useState({});
  const { open } = useContext(FilterContext)

  const [apiMessage, setApiMessage] = useState("");
  const currentDate = new Date();
  const monthIndex = currentDate.getMonth();
  // console.log("Month Index", monthIndex)
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const currentMonthName = monthNames[monthIndex];
  const { superArn: parArn, childArn } = useContext(FilterContext);
  useEffect(() => {
    // const urlParams = new URLSearchParams(window.location.search);
    // const parArn = urlParams.get("arn");
    // const childArn = urlParams.get("childArn");
    fetchFaultcodeDataAPI(parArn, childArn);
  }, []);

  const fetchFaultcodeDataAPI = async (parArn, childArn) => {
    try {
      // setLoading(true);
      const apiData = await fetchFaultcodeData(parArn, childArn);

      setFaultData(apiData || {});
      setApiMessage(apiData);
      if (!apiData) {
        console.error("API response is empty or invalid:", apiData);
        return;
      }
    } catch (error) {
      console.error("Error fetching complaint data:", error);
      setApiMessage("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-2">
      <div className={`bg-[#056DB3] w-96 md:w-full md:${open ? 'w-[1000px]' : 'w-[1200px]'} rounded-t-md    text-white  font-bold`}>
        <div className="flex gap-2 w-96 md:w-full">
          <h1 className="p-1 pl-2  w-96 md:w-full text-md">Fault Code Analysis - {`( ${currentMonthName} )`}</h1>
        </div>
      </div>
      <div className={`block md:flex gap-2 mt-3 ${open ? 'w-[1000px]' : ""}`}>
        {!loading && Object.keys(faultData).length > 0 ? (
          <>
            <AnalysisTable faultData={faultData} />
            <AnalysisChart faultData={faultData} />
          </>
        ) : (
          <div className="text-center w-full py-5">
            <div className="p-2 text-red-400 flex items-center justify-center">
              No data found. Please select valid parameters.
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default FaultCode;
